var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-view-layout',{attrs:{"title":"Manage Products"}},[_c('products-manager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }